<template lang="pug">
  BaseTable(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :table="table"
    :items="items"
    :meta="meta"
    :sort="sort"
    :page="page"
    :onDelete="onDelete"
    :toggleSort="toggleSort"
    :changePage="changePage"
  )
</template>

<script>
import BaseTable from '@/components/app/BaseTable'
import store from '@/store'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { BaseTable },
  data: vm => ({
    title: vm.$t('media.title')
  }),
  computed: {
    ...mapState('newsMedia', ['routeKey', 'routes', 'table', 'items', 'meta', 'sort', 'page']),
    crumbs: vm => [
      { text: vm.$t('news.title'), to: { name: 'news.index' } },
      { text: vm.$t('news.edit', { id: vm.$route.params.newsId }), to: { name: 'news.edit' } },
      { text: vm.$t('media.title') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('newsMedia/fetchItems', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapMutations('newsMedia', ['SET_SORT', 'SET_PAGE']),
    async onDelete (id) {
      await store.dispatch('newsMedia/deleteItem', { route: this.$route, id })
      await store.dispatch('newsMedia/fetchItems', { route: this.$route })
      this.$notify({ message: this.$t('forms.notify.deleted') })
    },
    async toggleSort (field) {
      this.SET_SORT(field)
      await store.dispatch('newsMedia/fetchItems', { route: this.$route })
    },
    async changePage (page) {
      this.SET_PAGE(page)
      await store.dispatch('newsMedia/fetchItems', { route: this.$route })
    }
  }
}
</script>
